import { Button, Modal, ModalProps } from 'antd';
import { useIntl } from 'react-intl';
import { ReactComponent as ExclamationIcon } from 'shared/assets/svg/exclamation.svg';

const ConfirmModal: React.FC<ModalProps> = ({ onOk, onCancel, open, ...props }) => {
  const { formatMessage: t } = useIntl();

  return (
    <Modal
      {...props}
      centered
      open={open}
      onCancel={onCancel}
      footer={null}
      closeIcon={<span style={{ fontSize: 20, color: '#000' }}>×</span>}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 16
        }}
      >
        <ExclamationIcon
          style={{ color: '#FF2E2E', fontSize: 64, marginBottom: 16 }}
          width={64}
          height={64}
        />
        <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8, textAlign: 'center' }}>
          {t({ id: 'blockCard.confirm.title', defaultMessage: 'Are you sure' })}
        </div>
        <div style={{ color: '#191919', fontSize: 14, marginBottom: 24, textAlign: 'center' }}>
          {t({
            id: 'blockCard.confirm.desc',
            defaultMessage:
              'When the card is blocked you can only order new one. The old one is not to be unblocked.'
          })}
        </div>
        <Button
          block
          style={{ marginBottom: 12, background: '#191919', color: '#fff', fontWeight: 500 }}
          onClick={onCancel}
        >
          {t({ id: 'button.simple.cancel', defaultMessage: 'Cancel' })}
        </Button>
        <Button block type='text' style={{ color: '#FF2E2E', fontWeight: 500 }} onClick={onOk}>
          {t({ id: 'blockCard.confirm.block', defaultMessage: 'Block card' })}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
